import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useWineContext } from '../context/WineContext';
import { Zap, Info, Crown, Gem, X, PlaySquare, ArrowRight, ShieldCheck, CheckCircle2, Plus } from 'lucide-react-native';
// --- IMPORTIAMO IL NOSTRO MOTORE PUBBLICITARIO ---
import RewardedAdModal from './RewardedAdModal';

export default function EnergyHeader() {
  const navigation = useNavigation();
  const { userProfile, addEnergy, t } = useWineContext();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showAdModal, setShowAdModal] = useState(false);
  // Stato per aprire il video
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  // Stato per il messaggio di successo

  if (!userProfile) return null;

  const { energia, isPremium, premiumType } = userProfile;

  // FUNZIONE CHIAMATA QUANDO IL VIDEO È CONCLUSO CON SUCCESSO
  const handleVideoComplete = () => {
    setShowAdModal(false);
    addEnergy(5); // Aggiunge 5 punti su Firebase!
    
    // Mostriamo un piccolo feedback visivo all'utente
    setTimeout(() => {
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }, 500);
  };

  const isUltimateLayout = isPremium && (premiumType === 'lifetime' || premiumType === 'ultimate');

  // --- STATO 3: ULTIMATE (LIFETIME UNA TANTUM) ---
  if (isUltimateLayout) {
    return (
      <View style={[styles.container, styles.ultimateContainer]}>
        <View style={styles.statusGroup}>
          <Gem color="#ffffff" size={20} style={{ marginRight: 6 }} />
          <Text style={styles.premiumText}>{t('components.energyHeader.ultimate')}</Text>
        </View>
        <TouchableOpacity style={styles.infoBtn} onPress={() => setShowInfoModal(true)}>
          <Info color="#ffffff" size={20} />
        </TouchableOpacity>
        {renderInfoModal()}
      </View>
    );
  }

  // --- STATO 2: PREMIUM PRO ---
  if (isPremium) {
    return (
      <View style={[styles.container, styles.proContainer]}>
        <View style={styles.statusGroup}>
          <Crown color="#ffffff" size={20} style={{ marginRight: 6 }} />
          <Text style={styles.premiumText}>{t('components.energyHeader.pro')}</Text>
        </View>
        <TouchableOpacity style={styles.infoBtn} onPress={() => setShowInfoModal(true)}>
          <Info color="#ffffff" size={20} />
        </TouchableOpacity>
        {renderInfoModal()}
      </View>
    );
  }

  // --- STATO 1: STANDARD (FREE CON ENERGIA E BOTTONE ABBONATI) ---
  return (
    <View style={[styles.container, styles.standardContainer]}>
      {/* Contatore Energia Cliccabile (Ricarica Preventiva) */}
      <TouchableOpacity 
        style={styles.energyPill} 
        onPress={() => setShowInfoModal(true)}
        activeOpacity={0.8}
      >
        <Zap color="#e11d48" size={16} fill="#e11d48" style={{ marginRight: 4 }} />
        <Text style={styles.energyText}>
          {Number.isFinite(energia) ? energia : 5}
        </Text>
        <View style={styles.plusIconWrap}>
          <Plus color="#ffffff" size={12} strokeWidth={3} />
        </View>
      </TouchableOpacity>

      {/* Area Azioni (Info e Abbonati) */}
      <View style={styles.actionGroup}>
        <TouchableOpacity style={styles.infoBtn} onPress={() => setShowInfoModal(true)}>
          <Info color="#ffffff" size={20} />
        </TouchableOpacity>

        <TouchableOpacity 
          style={styles.subscribeBtn} 
          onPress={() => {
            setShowInfoModal(false);
            navigation.navigate('Paywall'); 
          }}
        >
          <Crown color="#e11d48" size={14} style={{ marginRight: 4 }} />
          <Text style={styles.subscribeBtnText}>{t('components.energyHeader.subscribe')}</Text>
        </TouchableOpacity>
      </View>
      
      {renderInfoModal()}

      {/* MODAL DEL VIDEO PUBBLICITARIO (Invisibile finché non viene chiamato) */}
      <RewardedAdModal 
        visible={showAdModal} 
        onClose={() => setShowAdModal(false)} 
        onReward={handleVideoComplete} 
      />

      {/* PICCOLO TOAST DI SUCCESSO DOPO IL VIDEO */}
      <Modal transparent={true} visible={showSuccessToast} animationType="fade">
        <View style={styles.toastOverlay}>
          <View style={styles.toastBox}>
            <CheckCircle2 color="#10b981" size={24} style={{marginRight: 8}} />
            <Text style={styles.toastText}>{t('components.energyHeader.toastSuccess')}</Text>
          </View>
        </View>
      </Modal>

    </View>
  );

  // --- IL MODALE INFORMATIVO E DI RICARICA (COMUNE A TUTTI GLI STATI) ---
  function renderInfoModal() {
    return (
      <Modal transparent={true} visible={showInfoModal} animationType="fade" onRequestClose={() => setShowInfoModal(false)}>
        <View style={styles.modalOverlay}>
          <View style={styles.modalBox}>
            <View style={styles.modalHeader}>
              <View style={styles.modalTitleRow}>
                {isPremium ? (
                  isUltimateLayout ? <Gem color="#a855f7" size={24} /> : <Crown color="#d97706" size={24} />
                ) : (
                  <Zap color="#e11d48" size={24} fill="#e11d48" />
                )}
                <Text style={styles.modalTitle}>
                  {isPremium ? t('components.energyHeader.premiumTitle') : t('components.energyHeader.energyTitle')}
                </Text>
              </View>
              <TouchableOpacity onPress={() => setShowInfoModal(false)} style={styles.closeBtn}>
                <X color="#64748b" size={24} />
              </TouchableOpacity>
            </View>

            {isPremium ? (
              // Messaggio per utenti paganti
              <View style={styles.modalBody}>
                <Text style={styles.modalMessage}>{t('components.energyHeader.thanksSupport')}</Text>
                <Text style={styles.modalMessage}>
                  {t('components.energyHeader.asUser')}
                  <Text style={{fontWeight: 'bold', color: isUltimateLayout ? '#a855f7' : '#d97706'}}>
                    {isUltimateLayout ? t('paywall.plans.lifetime.title') : t('paywall.plans.monthly.title')}
                  </Text>
                  {t('components.energyHeader.unlockedPotential')}
                </Text>
                <View style={styles.premiumPerks}>
                  <View style={styles.perkRow}><ShieldCheck color="#10b981" size={18}/><Text style={styles.perkText}>{t('components.energyHeader.perkAds')}</Text></View>
                  <View style={styles.perkRow}><ShieldCheck color="#10b981" size={18}/><Text style={styles.perkText}>{t('components.energyHeader.perkActions')}</Text></View>
                  <View style={styles.perkRow}><ShieldCheck color="#10b981" size={18}/><Text style={styles.perkText}>{t('components.energyHeader.perkDevelopment')}</Text></View>
                </View>
              </View>
            ) : (
              // Messaggio per utenti gratuiti
              <View style={styles.modalBody}>
                <Text style={styles.modalMessage}>{t('components.energyHeader.freeAppDesc')}</Text>
                <Text style={styles.modalMessage}>{t('components.energyHeader.energySystemDesc')}</Text>
                
                <Text style={styles.modalSubTitle}>{t('components.energyHeader.howToRefill')}</Text>
                
                <View style={styles.rechargeOptions}>
                  {/* Opzione 1: Video */}
                  <TouchableOpacity style={styles.videoOptionBtn} onPress={() => {
                    setShowInfoModal(false);
                    setShowAdModal(true); // APRE IL VERO MOTORE PUBBLICITARIO
                  }}>
                    <PlaySquare color="#0f172a" size={24} style={{marginRight: 10}} />
                    <View style={{flex: 1}}>
                      <Text style={styles.optionTitle}>{t('components.energyHeader.watchVideo')}</Text>
                      <Text style={styles.optionSub}>{t('components.energyHeader.freeGetEnergy')}</Text>
                    </View>
                  </TouchableOpacity>

                  {/* Opzione 2: Abbonamento */}
                  <TouchableOpacity style={styles.proOptionBtn} onPress={() => {
                    setShowInfoModal(false);
                    navigation.navigate('Paywall'); 
                  }}>
                    <Crown color="#fff" size={24} style={{marginRight: 10}} />
                    <View style={{flex: 1}}>
                      <Text style={styles.optionTitlePro}>{t('components.energyHeader.buyGlass')}</Text>
                      <Text style={styles.optionSubPro}>{t('components.energyHeader.unlockAppDesc')}</Text>
                    </View>
                    <ArrowRight color="#fff" size={20} />
                  </TouchableOpacity>
                </View>
              </View>
            )}
          </View>
        </View>
      </Modal>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
    paddingHorizontal: 20, paddingVertical: 10,
    marginTop: Platform.OS === 'ios' ? 50 : 40,
    backgroundColor: 'transparent', 
  },
  standardContainer: { backgroundColor: 'transparent' },
  proContainer: { backgroundColor: 'transparent' },
  ultimateContainer: { backgroundColor: 'transparent' },

  energyPill: {
    flexDirection: 'row', alignItems: 'center', backgroundColor: '#ffffff',
    paddingLeft: 12, paddingRight: 6, paddingVertical: 6, borderRadius: 20,
    elevation: 3, 
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', 
  },
  energyText: { fontSize: 16, fontWeight: 'bold', color: '#e11d48', marginRight: 6 },
  plusIconWrap: {
    backgroundColor: '#e11d48',
    borderRadius: 10,
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center'
  },

  actionGroup: { flexDirection: 'row', alignItems: 'center', gap: 12 },
  subscribeBtn: {
    flexDirection: 'row', alignItems: 'center', backgroundColor: '#ffffff', 
    paddingHorizontal: 12, paddingVertical: 8, borderRadius: 12,
    elevation: 3, 
    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', 
  },
  subscribeBtnText: { color: '#e11d48', fontWeight: 'bold', fontSize: 13 },

  statusGroup: { flexDirection: 'row', alignItems: 'center' },
  premiumText: { fontWeight: 'bold', color: '#ffffff', fontSize: 15, letterSpacing: 0.5 },
  infoBtn: { padding: 6, backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: 20 },

  modalOverlay: { flex: 1, backgroundColor: 'rgba(15, 23, 42, 0.7)', justifyContent: 'center', alignItems: 'center', padding: 20 },
  modalBox: { backgroundColor: '#fff', borderRadius: 24, padding: 24, width: '100%', maxWidth: 400, elevation: 10 },
  modalOverlay: { flex: 1, backgroundColor: 'rgba(15, 23, 42, 0.7)', justifyContent: 'center', alignItems: 'center', padding: 20 },
  modalBox: { backgroundColor: '#fff', borderRadius: 24, padding: 24, width: '100%', maxWidth: 400, elevation: 10 },
  modalHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 },
  modalTitleRow: { flexDirection: 'row', alignItems: 'center', flex: 1 },
  modalTitle: { fontSize: 20, fontWeight: 'bold', color: '#0f172a', marginLeft: 10 },
  closeBtn: { padding: 4, backgroundColor: '#f1f5f9', borderRadius: 16 },
  modalBody: { marginTop: 4 },
  modalMessage: { fontSize: 15, color: '#475569', lineHeight: 22, marginBottom: 12 },
  modalSubTitle: { fontSize: 16, fontWeight: 'bold', color: '#0f172a', marginTop: 12, marginBottom: 12 },
  
  rechargeOptions: { gap: 12, marginBottom: 4 },
  videoOptionBtn: { flexDirection: 'row', alignItems: 'center', backgroundColor: '#f8fafc', padding: 16, borderRadius: 16, borderWidth: 1, borderColor: '#e2e8f0' },
  optionTitle: { fontSize: 15, fontWeight: 'bold', color: '#0f172a' },
  optionSub: { fontSize: 13, color: '#64748b', marginTop: 2 },
  
  proOptionBtn: { 
    flexDirection: 'row', alignItems: 'center', backgroundColor: '#d97706', 
    padding: 16, borderRadius: 16, elevation: 4,
    boxShadow: '0px 4px 6px rgba(217, 119, 6, 0.3)', 
  },
  optionTitlePro: { fontSize: 16, fontWeight: 'bold', color: '#fff' },
  optionSubPro: { fontSize: 13, color: 'rgba(255,255,255,0.9)', marginTop: 2, lineHeight: 18 },

  premiumPerks: { backgroundColor: '#f8fafc', padding: 16, borderRadius: 16, marginTop: 12, gap: 10 },
  perkRow: { flexDirection: 'row', alignItems: 'center' }, perkText: { marginLeft: 8, fontSize: 15, color: '#334155', fontWeight: '500' },

  // Toast di successo a scomparsa
  toastOverlay: { flex: 1, justifyContent: 'flex-end', alignItems: 'center', paddingBottom: 100 },
  toastBox: { flexDirection: 'row', alignItems: 'center', backgroundColor: '#ffffff', paddingHorizontal: 24, paddingVertical: 14, borderRadius: 30, elevation: 6, boxShadow: '0px 4px 12px rgba(0,0,0,0.15)' },
  toastText: { color: '#0f172a', fontWeight: 'bold', fontSize: 16 }
});